import { CustomFormatter } from "@messageformat/core"

// @ts-ignore
export const upperCase: CustomFormatter = (value, locale, arg) => value.toUpperCase()
